import React from "react";
import hireMe from "../assets/images/hire_me2.png";
const Hireme = () => {
  return (
    <section id="hireme" className="py-10 px-3 text-white">
      <div className="text-center">
        <h3 className="text-5xl font-semibold">
          Hire <span className="text-cyan-600">Me</span>
        </h3>
        <p className="text-gray-400 mt-3 text-xl">Do you have any work?</p>
      </div>
      <div className="bg-gray-700 relative px-8 rounded-2xl py-5 lg:max-w-4xl mx-auto min-h-[24rem] mt-24 flex gap-6 lg:flex-row flex-col-reverse items-center">
        <div>
          <h2 className="text-2xl font-semibold">
            Do you want any work from me?
          </h2>
          <p className="lg:text-left text-justify max-w-lg text-lg mt-4 text-gray-200 leading-6">
            As a Professional Full Stack Developer, I take pride in delivering
            top-notch work at a reasonable price. When it comes to React JS,
            NextJS, and NodeJS, I am your go-to person. I welcome friendly
            conversations where you can share any issues or bugs in your Web
            App, as well as your ideas to bring them to life as real ReactJS /
            NextJS Web Apps. Looking to take your business to new heights? I
            specialize in building Hybrid (Incremental Static Site Generation +
            Server-Side Rendering) NextJS apps that will elevate your business
            and propel it to the moon. Let's collaborate and turn your visions
            into reality!
          </p>
          <a href="#contact">
            <button className="btn-primary mt-10">Say Hello</button>
          </a>
        </div>
        <img src={hireMe} alt="" className="mx-auto rounded-[50%] w-[45%] md:mb-20" />
      </div>
    </section>
  );
};

export default Hireme;
